import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnauthedHubSpotUserAvatar } from 'avatar-components/UnauthedHubSpotUserAvatar';
import { formatFullNameAndEmailSeperately } from '../../utils/UserUtils';
import { Flex } from 'foundations-components/components/Flex';
import { MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedUserOption = ({
  id,
  email,
  canRemoveUser,
  disallowedUserTooltip,
  onRemoveUser,
  selectedUserInfo,
  user
}) => {
  const {
    userBadge
  } = selectedUserInfo && selectedUserInfo[id] || {};
  const {
    formattedEmail,
    formattedFullName
  } = formatFullNameAndEmailSeperately(user);
  const displayName = formattedFullName || formattedEmail;
  const maybeDisplayEmailFollowingFullName = formattedFullName ? formattedEmail : null;
  return /*#__PURE__*/_jsxs(MultiColumnGroup, {
    children: [/*#__PURE__*/_jsx(MultiColumnItem, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(UnauthedHubSpotUserAvatar, {
          size: "sm",
          hubSpotUserEmail: email
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          flexDirection: "column",
          marginInlineStart: "600",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [displayName, userBadge]
          }), maybeDisplayEmailFollowingFullName]
        })]
      })
    }), /*#__PURE__*/_jsx(MultiColumnItem, {
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": `remove-user-button-${id}`,
        tooltip: canRemoveUser ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.removeUser"
        }) : disallowedUserTooltip && /*#__PURE__*/_jsx(FormattedMessage, {
          message: disallowedUserTooltip
        }),
        size: "extra-small",
        use: "transparent",
        disabled: canRemoveUser === undefined ? false : !canRemoveUser,
        onClick: () => onRemoveUser(id),
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
};
SelectedUserOption.propTypes = {
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  selectedUserInfo: PropTypes.object
};
export default SelectedUserOption;